export default {
  white: '#ffffff',
  orange: '#ff7f19',
  black: '#182a33',
  semi: '#a8afb3',
  low: '#e2e4e5',
  red: '#f93918',
};
